<template>
  <div v-if="noticeCourse" class="signUpToast">
    <!-- <div class="course_next"> -->
    <!-- <h3 class="tit">
                <span></span>{{noticeCourse.title}}
            </h3>
            <div class="info" v-if="noticeCourse.expert">授课嘉宾：{{noticeCourse.expert.realName}} {{noticeCourse.expert.hospital}}{{noticeCourse.expert.position}}</div>
            <div class="time"> -->
    <!-- returnDate(noticeCourse.startTime) -->
    <!-- <div class="time_l fl">开课时间：{{noticeCourse.startTime}}</div> -->
    <!-- <div class="time_r fr" @click="signUp">马上报名>></div> -->
    <!-- </div> -->
    <!-- </div> -->
    <div class="course_appointment">
      <p>{{ noticeCourse.title }}</p>
      <p>开课时间：{{ noticeCourse.startTime }}</p>
      <span>{{ fomatterNum(noticeCourse.clickNum) || 0 }}人已报名</span>
      <span @click="signUp">预约课程</span>
    </div>
    <!-- 报名成功弹窗 -->
    <div class="successToast" @touchmove.prevent @mousewheel.prevent>
      <div class="toast_inner">
        <span class="close" @click="closeToast"></span>
        <div class="toast_icon">
          <img alt="" src="../../../assets/images/icon/xiaohe1.png"/>
        </div>
        <h2>{{ toastHtml.message }}</h2>
        <p class="toast_info">{{ toastHtml.tips }}</p>
        <span class="toast_btn" @click="moreCourese">查看更多课程</span>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
// 预约内容
.course_appointment {
  margin-bottom: 10px;
  background: #fffdf6;
  border-radius: 4px;
  padding: 10px 0 10px 10px;
  box-sizing: border-box;
  height: 76px;

  > p:nth-of-type(1) {
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 18px;
  }

  > p:nth-of-type(2) {
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 0.7);
    line-height: 14px;
  }

  > span:nth-of-type(1) {
    display: inline-block;
    margin-top: 10px;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 0.5);
    line-height: 14px;
  }

  > span:nth-of-type(2) {
    float: right;
    margin-right: 9px;
    width: 76px;
    height: 24px;
    display: inline-block;
    background: #ffffff;
    border-radius: 15px;
    border: 1px solid #e0b76b;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #e0b76b;
    line-height: 24px;
    text-align: center;
  }
}

.signUpToast {
  .course_next {
    padding: 13px 20px 15px;
    overflow: hidden;

    .tit {
      font-size: @indexFontSize14;
      color: rgb(27, 25, 25);
      font-weight: bold;
      line-height: 1.2em;
      margin-bottom: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      span {
        font-size: @indexFontSize12;
        color: @mainColor;
      }
    }

    .info {
      color: @expertFontColor51;
      font-size: @indexFontSize12;
      margin-bottom: 8px;
    }

    .time {
      font-size: @indexFontSize14;
      line-height: 1.2em;

      .time_l {
        color: @expertFontColor153;
        font-size: @indexFontSize12;
      }

      .time_r {
        color: @mainColor;
        font-weight: bold;
      }
    }
  }

  .successToast {
    width: 100%;
    height: 100%;
    background: @toastMask;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    display: none;

    .toast_inner {
      width: 258px;
      height: 312px;
      background: rgba(255, 249, 228, 1);
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 8px;

      span.close {
        width: 30px;
        height: 30px;
        display: block;
        background-image: url(../../../assets/images/icon/close2.png);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 15px;
        position: absolute;
        top: 9px;
        right: 9px;
      }

      .toast_icon {
        width: 97px;
        height: 97px;
        background: rgba(255, 209, 107, 1);
        border-radius: 50%;
        margin: 46px auto 6px;
        overflow: hidden;

        img {
          width: 61px;
          margin: 22px 18px 0;
        }
      }

      h2 {
        font-size: @indexFontSize18;
        color: @mainColor2;
        text-align: center;
        margin-bottom: 16px;
      }

      p.toast_info {
        font-size: @indexFontSize14;
        color: @mainColor2;
        text-align: justify;
        line-height: 22px;
        margin: 0 16px 12px;
      }

      span.toast_btn {
        width: 140px;
        height: 36px;
        background: linear-gradient(270deg,
        rgba(212, 164, 55, 1) 0%,
        rgba(229, 191, 93, 1) 100%);
        border-radius: 17px;
        color: @expertFontColor255;
        font-size: @indexFontSize18;
        margin: 0 58px;
        display: inline-block;
        text-align: center;
        line-height: 36px;
      }
    }
  }
}
</style>

<script>
import {fomatterNum, getCookie, is_weixin} from "@/assets/js/common.js";

export default {
  name: "signUpToast",
  data() {
    return {
      noticeCourse: null, //下期预告
      toastHtml: "报名成功",
      userInfo: {},
      handleParams: {
        type: "courseSign",
        number: 0,
      },
      isSignUp: true,
    };
  },
  props: {},
  mounted() {
    this.getNoticeCouese();
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    getCookie,
    is_weixin,
    fomatterNum,
    // 获取下期预告
    getNoticeCouese: function () {
      this.$http.post("/motherCourse/getCourseNotice", {}, {}, (res) => {
        if (res.code === 200) {
          this.noticeCourse = res.data;
          if (this.noticeCourse == null) {
            this.$emit("courseData", false);
            return false;
          } else {
            this.handleParams.number = this.noticeCourse.id;
            this.$emit("courseData", true);
            this.checkSignUp();
            var that = this;
            this.wxJsSet.wxLoginFn(this, this.handleParams, function () {
              if (
                  that.isSignUp &&
                  that.$route.query.courseSign ==
                  that.isSignUp &&
                  that.$route.query.courseSign ==
                  localStorage.getItem("courseSign")
              ) {
                that.signUpAjax();
              } else {
                localStorage.removeItem("courseSign");
              }
            });
          }
        }
      }, null, 'lucky');
    },
    // 检验是否报名过
    checkSignUp: function () {
      this.$http.get(
          "/motherCourse/checkCourseSignUp",
          {crm_id: this.userInfo.crm_id, id: this.noticeCourse.id},
          (res) => {
            if (res.code == 200) {
              if (res.data == true) {
                this.isSignUp = false;
              } else {
                this.isSignUp = true;
              }
            }
          },
          null,
          'lucky'
      );
    },
    // 马上报名
    signUp: function () {
      var that = this;
      localStorage.setItem("courseSign", this.noticeCourse.id);
      this.wxJsSet.wxHandleBeforeFn(that, this.handleParams, that.signUpAjax);
      this.$emit("gioFloor", this.noticeCourse.title);
      // 预约埋点
      sensors.track("OperateClick", {
        operate_name: "星妈课堂",
        operate_content: "预告",
        content_name: this.noticeCourse.title,
      });
    },
    signUpAjax: function () {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      var openId = "";
      if (this.getCookie("xmh_openid") && this.getCookie("xmh_openid") != "")
        openId = this.getCookie("xmh_openid");
      this.$http.post(
          "/motherCourse/courseSignUp",
          {},
          {
            id: this.noticeCourse.id,
            crmId: this.userInfo.crm_id,
            mobile: this.userInfo.mobile,
            openId: openId,
            nickName: unescape(getCookie("xmh_nickname")),
          },
          (res) => {
            if (res.code === "200") {
              // if($(window).scrollTop()==0 && this.$route.name=="home"){
              //     $('body,html').animate({
              //         scrollTop: document.getElementsByClassName("course_recommend")[0].offsetTop
              //     },10);
              // }
              console.log(res)
              $(".successToast").fadeIn(200);
              this.toastHtml = res.data;
              localStorage.removeItem("courseSign");
            }
          },
          null,
          'lucky'
      );
    },
    // 关闭弹窗
    closeToast: function () {
      $(".successToast").fadeOut(200);
    },
    // 查看更多课程
    moreCourese: function () {
      if (this.$route.name == "courseList") {
        $(".successToast").fadeOut(200);
      } else {
        location.href = "/course";
      }
    },
    returnDate: function (date) {
      var month = new Date(date).getMonth() + 1;
      var day = new Date(date).getDate();
      var weekday = new Array(7);
      weekday[0] = "星期日";
      weekday[1] = "星期一";
      weekday[2] = "星期二";
      weekday[3] = "星期三";
      weekday[4] = "星期四";
      weekday[5] = "星期五";
      weekday[6] = "星期六";
      var week = weekday[new Date(date).getDay()];
      var hours = new Date(date).getHours();
      if (hours < 10) hours = "0" + hours;
      var minute = new Date(date).getMinutes();
      if (minute < 10) minute = "0" + minute;
      return month + "月" + day + "日 " + week + " " + hours + ":" + minute;
    },
  },
};
</script>
